import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { cssTransition, ToastContainer, toast } from "react-toastify";
import { PersistGate } from "redux-persist/integration/react";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
import { ErrorIcon, InfoIcon, SuccessIcon, WarningIcon } from "~/components/ui/ToastIcons";
import { persistor, store } from "~/store";
import App from "./App";
import "./styles/toast.scss";

// エラートーストは自動で消えないようにする（ユーザーが閉じるまで表示）
const originalError = toast.error.bind(toast);
toast.error = ((content, options) => {
  return originalError(content, { ...options, autoClose: false });
}) as typeof toast.error;

// Custom fade transition
const fade = cssTransition({
  enter: "fadeIn",
  exit: "fadeOut",
  appendPosition: false,
  collapse: false,
});

// 入力デバイスに応じてフォーカス表示を切り替える（Keyboardのみ可視）
(() => {
  const addKeyboardClass = () => document.body.classList.add("user-is-tabbing");
  const removeKeyboardClass = () => document.body.classList.remove("user-is-tabbing");
  window.addEventListener(
    "keydown",
    (e) => {
      // Tab/矢印/Enter/Escape などでキーボード操作を検知
      const keys = [
        "Tab",
        "ArrowUp",
        "ArrowDown",
        "ArrowLeft",
        "ArrowRight",
        "Enter",
        "Escape",
        " ",
      ];
      if (keys.includes(e.key)) addKeyboardClass();
    },
    true,
  );
  window.addEventListener("mousedown", removeKeyboardClass, true);
  window.addEventListener("pointerdown", removeKeyboardClass, true);
  window.addEventListener("touchstart", removeKeyboardClass, true);
})();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <Provider store={store}>
    <ToastContainer
      position="top-center"
      autoClose={3000}
      hideProgressBar
      newestOnTop
      closeOnClick
      rtl={false}
      pauseOnFocusLoss={false}
      draggable={false}
      pauseOnHover={false}
      transition={fade}
      className="custom-toast-container"
      toastClassName="custom-toast"
      style={{ zIndex: 99999 }}
      data-testid="toast-container"
      icon={({ type }) => {
        switch (type) {
          case "success":
            return <SuccessIcon />;
          case "error":
            return <ErrorIcon />;
          case "info":
            return <InfoIcon />;
          case "warning":
            return <WarningIcon />;
          default:
            return null;
        }
      }}
    />
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
);

reportWebVitals();
